import "./ErrorPages.css";

import image404 from '../../assets/customTags/404.png';

function NotFound() {
  return (
    <div className="not-found">
      <img src={image404} alt="404" />
      <p className="not-found-title">Error 404</p>
      <p>The page or resource was not found</p>
    </div>
  );
}

export default NotFound;
